import appConfig from './appConfig';
export default appConfig;